export default {"src":"/_next/static/media/racoon_money.7393c3d4.svg","height":87,"width":87};